import { createReducer } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { getTeamDispositions } from '../../redux';
const initialState = {
    teamDispositions: [],
    total: 0,
    error: null,
    isLoading: false,
};
const teamDispositions = createReducer(initialState, (builder) => {
    builder
        .addCase(getTeamDispositions.request, (state) => {
        state.isLoading = true;
        state.error = null;
    })
        .addCase(getTeamDispositions.success, (state, action) => {
        const { data: { data, total } } = action.payload;
        state.teamDispositions = data.map(({ polygon_id: id, team_name: teamName, not_knocked: notKnocked, knocked_once: knockedOnce, knocked_twice: knockedTwice, completed, }) => ({
            id,
            teamName,
            notKnocked,
            knockedOnce,
            knockedTwice,
            completed,
        }));
        state.total = total;
        state.isLoading = false;
    });
});
export default teamDispositions;
